<script setup lang="ts">
import { MutationTypes, type State } from '@/store/store_types';
import { useStore } from 'vuex';

const store = useStore<State>()
function handleShowAgain() {
  store.commit(MutationTypes.setDSA_tutorial_wizard, false)
}

function handleDoNotShowAgain() {
  store.commit(MutationTypes.setDSA_tutorial_wizard, true)
}

</script>
<template>
  <v-checkbox
    color="pwt_palatinate_blue"
    base-color="pwt_palatinate_blue"
    hide-details
    density="compact"
    @update:modelValue="
      (val) => {
        if (val) handleDoNotShowAgain()
        else handleShowAgain()
      }
    "
  >
    <template v-slot:label>
      <span class="text-pwt_palatinate_blue text-decoration-underline text-caption">
        Don't show again
      </span>
    </template>
  </v-checkbox>
</template>
